import React from "react";
import { useDispatch } from "react-redux";
import { bookUpdateAction } from "../actionCreators";
import ModalPopup from "./ModalPopup";

const ModalContainer = ({ onClose, ordNum }) => {
  const dispatch = useDispatch();

  const onSubmit = (rejectReason, status) => {
    dispatch(bookUpdateAction({ ordNum, rejectReason, status }));
  };

  return <ModalPopup onClose={onClose} onSubmit={onSubmit} />;
};

export default ModalContainer;
